<template>
  <div>
     <div class="codeBox pcShow">
      <div class="container section2Box">
        <div class="codeBoxPic">
          <img class="code" :src="code?code:require('../../assets/picture/occupation/t15.png')">       
        </div>
        <!-- <img width="274" src="../../assets/picture/occupation/t14.png"> -->
        <div class="destiption">
          <p>{{$t('code.welcome')}}</p>
       
          <p v-if="$t('code.jiaqi')"><span>{{$t('code.contact')}}<span class="fwb" v-if="$t('code.jiaqi')"> 「{{$t('code.jiaqi')}}」</span></span></p>
          <p v-if="!$t('code.jiaqi')"><span class="contactTxt fwb" :style="lang=='en'?'marginLeft:-15px':''">「{{$t('code.contact')}}」</span></p>
        </div>
        <div class="destiption">
          <p>{{$t('code.send')}} </p>
          <p class="fz22">{{email}}</p>
        </div>
      </div>
    </div>
    <div class="codePhoneBox phoneShow">
      <div class="topTxt">
        <p>{{$t('code.welcome')}}</p>
        <p v-if="!$t('code.jiaqi')">「{{$t('code.contact')}}」</p>
        <p v-if="$t('code.jiaqi')">{{$t('code.contact')}}</p>
        <p><span v-if="$t('code.jiaqi')"> 「{{$t('code.jiaqi')}}」</span></p>
        <span class="line"></span>
      </div>
      <div class="middleTxt">
        <p>{{$t('code.send')}}</p>
        <p class="fz20">{{email}}</p>
      </div>
      <div class="codeBoxPic">
        <img class="code" :src="code?code:require('../../assets/picture/occupation/t15.png')">       
      </div>
    </div>
   
  </div>
</template>

<script>
export default {
  name: 'Code',
  data() {
    return {
      eMail:'',
      lang:'',
      email:'',
      code:'',
    };
  },
  mounted(){
    // this.getContactUs();
    this.lang = window.sessionStorage.getItem("language");
    this.getConfig();
  },
  methods: {
    //获取基础配置信息
    async getConfig() {
        const { data: res } = await this.$http.get("/config/getConfig.do");
        if (res.code !== 200) return this.$message.error(res.message);
        this.email = res.data.email;
        this.code = res.data.qrCodeUrl;
      },
    // 获取联系我们
    // async getContactUs() {
    //     const { data: res } = await this.$http.get("/article/getContactUs.do");
    //     // 提示message
    //     if (res.code !== 200) return this.$message.error(res.message);
    //     this.eMail = res.data.content;
    // },
  }
};
</script>

<style lang="less" scoped>
    body{
      width: 100%;
    }
     .codePhoneBox{
      background-image: url(../../assets/picture/occupation/p18.png);
      background-size: cover;
      width: 100%;
      padding-top:8rem;
      .topTxt{
        margin:0 auto;
        display: block;       
        font-size: 4.8rem;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 300;
        color: #FFFFFF;
        line-height: 8rem;
        text-align: center;
        .line{
          margin:0 auto;
          width: 16rem;
          height: 3px;
          background: #CD2A20;
          margin-top: 5rem;
          display: block;
        }
      }
      .codeBoxPic{
        width: 47rem;
        padding-top: 8rem;
        height: 53.6rem;
        display: block;
        margin:0 auto;
        background-image: url(../../assets/picture/occupation/t14.png);
        background-size: cover;
        .code{
          width: 31.4rem;
          display: block;
          margin:0 auto;
        }
      }
      .middleTxt{
        padding: 8rem 0;
        p{         
          font-size: 4.8rem;
          font-family: PingFangSC-Light, PingFang SC;
          font-weight: 300;
          color: #FFFFFF;
          line-height: 6.6rem;
          text-align: center;
        }
        .fz20{
          font-size: 4rem;
        }
      }
    }
    .codeBox{ 
      height: 430px;
      background-image: url(../../assets/picture/occupation/p18.png);
      background-size: cover;
      width: 100%;
      .section2Box{
        .codeBoxPic{
          margin-top: 20px;
          object-fit: scale-down;
          width: 285px;
          padding-top: 60px;
          height: 332px;
          padding-left: 35px;
          padding-top: 60px;
          margin-top: 98px;
          display: inline-block;
          background-image: url(../../assets/picture/occupation/t14.png);
          background-size: cover;
          .code{
            width: 210px;
            display: inline-block;
            margin:0 auto;
          }
        }
      /* img{
          margin-top: 20px;
          object-fit: scale-down;
        }*/
      .destiption{
        display: inline-block;
        height: 88px;
        border-right: 3px solid #CD2A20;
        margin:188px 0 154px 60px;        
        font-size: 25px;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 300;
        color: #FFFFFF;
        line-height: 40px;
        padding-right: 40px;
        .contactTxt{
          font-weight: 500;
        }
        .fwb{
          font-weight: bold;
        }
      }
      .destiption:last-of-type{
        padding-right: 0;
        border:none;
        margin-left: 40px;
        .fz22{
          /deep/ p{
            font-size: 22px;
            font-family: PingFangSC-Light, PingFang SC;
            font-weight: 300;
            color: #FFFFFF!important;
            line-height: 40px;
          }
          /deep/ a{
          font-size: 22px;
          font-family: PingFangSC-Light, PingFang SC;
          font-weight: 300;
          color: #FFFFFF!important;
          line-height: 40px;
        }
        /deep/ a:hover{
          font-size: 25px;
          font-family: PingFangSC-Light, PingFang SC;
          font-weight: 300;
          color: #FFFFFF !important;
          line-height: 40px;
        }
        }
      }
    } 
   
 }
</style>
